import React, { useState, useRef, useEffect } from "react";
import { Card } from "react-bootstrap";
import { FiRefreshCw, FiSend } from "react-icons/fi";
import { HiSparkles } from "react-icons/hi";

import titleIcon from "../../../assets/img/icons/title-icon-04.svg";
import titleBg from "../../../assets/img/bg/title-bg-04.png";

export default function HelpCard() {
  const [messages, setMessages] = useState([
    {
      type: "ai",
      text: "👋 Hi! I'm your AI HR Finance Assistant. I can help you analyze payroll costs, forecast budgets, identify compensation trends.",
    },
  ]);

  const [input, setInput] = useState("");
  const chatRef = useRef();

  // 🔥 Auto scroll
  useEffect(() => {
    chatRef.current?.scrollTo(0, chatRef.current.scrollHeight);
  }, [messages]);

  // 🔥 SEND MESSAGE
  const handleSend = () => {
    if (!input.trim()) return;

    const userMsg = { type: "user", text: input };

    setMessages((prev) => [...prev, userMsg]);

    // fake AI response
    setTimeout(() => {
      setMessages((prev) => [
        ...prev,
        {
          type: "ai",
          text: "Thanks! I'm analyzing your request. This is a demo AI response based on your input.",
        },
      ]);
    }, 800);

    setInput("");
  };

  return (
    <Card className="hcai-card">
      <Card.Body className="hcai-body">

        {/* HEADER */}
        <div className="hcai-header">
          <div className="hcai-left">
            <div className="hcai-avatar">
              <img src={titleIcon} className="hcai-icon" alt="" />
              <img src={titleBg} className="hcai-bg" alt="" />
            </div>

            <div>
              <h5 className="hcai-title">How can i help today</h5>
              <p className="hcai-sub">AI HR Finance Assistant</p>
            </div>
          </div>

          <button className="hcai-refresh">
            <FiRefreshCw />
          </button>
        </div>

        {/* CHAT AREA */}
        <div className="hcai-chat" ref={chatRef}>
          <div className="hcai-ai-label">
            <HiSparkles /> AI Assistant
          </div>

          {messages.map((msg, i) => (
            <div
              key={i}
              className={`hcai-msg ${
                msg.type === "user" ? "user" : "ai"
              }`}
            >
              {msg.text}
            </div>
          ))}
        </div>

        {/* INPUT */}
        <div className="hcai-input">
          <input
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Ask me anything about Finance...."
            onKeyDown={(e) => e.key === "Enter" && handleSend()}
          />

          <button onClick={handleSend} className="hcai-send">
            <FiSend />
          </button>
        </div>

      </Card.Body>

      {/* CSS */}
      <style>{`

        .hcai-card {
          border-radius: 12px;
          border: 1px solid #e5e7eb;
          height: 100%;
        }

        .hcai-body {
          display: flex;
          flex-direction: column;
          height: 100%;
        }

        .hcai-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .hcai-left {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .hcai-avatar {
          position: relative;
          width: 42px;
          height: 42px;
        }

        .hcai-icon {
          position: relative;
          z-index: 2;
          width: 28px;
        }

        .hcai-bg {
          position: absolute;
          width: 42px;
          top: 0;
          left: 0;
          opacity: 0.2;
        }

        .hcai-title {
          font-size: 18px;
          font-weight: 600;
          margin: 0;
        }

        .hcai-sub {
          font-size: 13px;
          color: #6b7280;
          margin: 0;
        }

        .hcai-refresh {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          border: 1px solid #e5e7eb;
          background: #f9fafb;
        }

        /* CHAT */
        .hcai-chat {
          flex: 1;
          overflow-y: auto;
          margin-top: 15px;
          padding-right: 5px;
        }

        .hcai-ai-label {
          color: #f26522;
          font-weight: 600;
          margin-bottom: 10px;
          display: flex;
          align-items: center;
          gap: 6px;
        }

        .hcai-msg {
          max-width: 80%;
          padding: 10px 14px;
          border-radius: 14px;
          margin-bottom: 10px;
          font-size: 14px;
        }

        .hcai-msg.ai {
          background: #f3f4f6;
          color: #374151;
        }

        .hcai-msg.user {
          background: #111827;
          color: #fff;
          margin-left: auto;
        }

        /* INPUT */
        .hcai-input {
          display: flex;
          align-items: center;
          border: 1px solid #e5e7eb;
          border-radius: 30px;
          padding: 6px;
          margin-top: 10px;
        }

        .hcai-input input {
          border: none;
          outline: none;
          flex: 1;
          padding: 10px;
          font-size: 14px;
        }

        .hcai-send {
          width: 42px;
          height: 42px;
          border-radius: 50%;
          background: #111827;
          color: #fff;
          border: none;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        /* MOBILE */
        @media (max-width: 768px) {
          .hcai-title {
            font-size: 16px;
          }

          .hcai-msg {
            max-width: 90%;
          }

          .hcai-input input {
            font-size: 13px;
          }
        }

      `}</style>
    </Card>
  );
}